// /js/pages/menu.js

import { registerUiHandler } from '/js/shared/extensions/domExtensions.js';
import {
  addEscapeKeyHandler,
  addClickOutsideHandler
} from '/js/shared/utils/EventScopeUtils.js';
import { detectSwipe } from '/js/shared/utils/TouchUtils.js';
import {
  setActiveOverlay,
  clearActiveOverlay
} from '/js/shared/utils/OverlayManager.js';

function handleMenuToggle(trigger) {
  const wrapper  = document.getElementById('mobile-menu-wrapper');
  const backdrop = document.getElementById('menu-overlay-backdrop');
  if (!wrapper || !backdrop) return;

  const isOpen = wrapper.classList.contains('open');

  if (isOpen) {
    closeMenu(wrapper, trigger, backdrop);
  } else {
    openMenu(wrapper, trigger, backdrop);
  }
}

function closeMenu(wrapper, toggleBtn, backdrop) {
  wrapper.classList.remove('open');
  toggleBtn.classList.remove('open');
  if (backdrop) backdrop.classList.remove('open');
  wrapper.style.paddingTop = '';

  clearActiveOverlay('menu'); // ✅ centralized cleanup
}

function openMenu(wrapper, toggleBtn, backdrop) {
  if (!backdrop) return;

  // Dynamically set padding-top based on header height
  requestAnimationFrame(() => {
    const header = document.getElementById('site-header');
    const height = header?.getBoundingClientRect().height ?? 96;
    wrapper.style.paddingTop = `${height}px`;
  });

  setActiveOverlay('menu');

  wrapper.classList.add('open');
  toggleBtn.classList.add('open');
  backdrop.classList.add('open');

  addEscapeKeyHandler(() => {
    closeMenu(wrapper, toggleBtn, backdrop);
  });

  addClickOutsideHandler(backdrop, toggleBtn, () => {
    closeMenu(wrapper, toggleBtn, backdrop);
  });
}

function initMenuSwipe() {
  const wrapper  = document.getElementById('mobile-menu-wrapper');
  const toggle   = document.querySelector('[data-ui="menu-toggle"]');
  const backdrop = document.getElementById('menu-overlay-backdrop');

  if (!wrapper || !toggle || !backdrop) return;

  detectSwipe(document.body, {
	 onSwipeLeft: () => {
      if (!wrapper.classList.contains('open')) {
        openMenu(wrapper, toggle, backdrop);
      }
    },
    onSwipeRight: () => {
      if (wrapper.classList.contains('open')) {
        closeMenu(wrapper, toggle, backdrop);
      }
    }
  });
}

registerUiHandler('click', 'menu-toggle', handleMenuToggle);
document.addEventListener('DOMContentLoaded', initMenuSwipe);